/**
 * 레이아웃 팝업 SavePoint - Rollback Store
 *
 * @since 2019-03-13
 * @author mk.ko
 * ---
 */

export const state = () => ({
  // 세이브/포인트 체크 내부 카운트
  savePointCnt: 0,
  // 팝업창 개수
  popupCnt: 0,
  popupList: []
})

export const mutations = {
  initStore (state) {
    state.savePointCnt = 0
    state.popupCnt = 0
    state.popupList = []
  },
  countSavePoint (state, payload) {
    state.savePointCnt = payload
  },
  addPopup (state, uid) {
    state.popupList.push(uid)
  },
  removePopup (state, uid) {
    // state.popupList.pop()
    // 순서대로 호출되지 않을 수 도 있음
    const popupList = _.cloneDeep(state.popupList)
    const idx = popupList.indexOf(uid)
    if (idx !== -1) {
      popupList.splice(idx, 1)
    }
    state.popupList = popupList
  },
  clearPopup (state) {
    state.popupList = []
  }
}

export const actions = {
  async setSavePoint () {
    try {
      const res = await this.$axios.$put('/api/cm/savepoint', void 0, {
        successAlert: false,
        loading: false
      })
      return res
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async rollbackSavePoint () {
    try {
      const res = await this.$axios.$delete('/api/cm/savepoint', {
        successAlert: false,
        loading: false
      })
      return res
    } catch (error) {
      return {code: 'error', errors: error}
    }
  }
}

export const getters = {
  popupCnt (state) {
    return state.popupList.length
  }
}

export const strict = false
